import Vue from 'vue/dist/vue.esm'

Vue.directive('capitalize', {
    inserted(el) {
        el.addEventListener('blur', () => {
            let value = el.value;
            if (value) {
                // Capitalize the first letter of each word
                el.value = value.toLowerCase()
                                .replace(/\b\w/g, char => char.toUpperCase());
                el.dispatchEvent(new Event('input')); // Trigger input event to update v-model
            }
        });
    }
})
